// extracted by mini-css-extract-plugin
export default {"returnReject":"src-pages-Order-Components-ReturnReject-css-module__returnReject--KuJ4P"};